export const changeDate = (
  dates: [Date | null, Date | null],
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>,
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>,
  startTime: string,
  endTime: string,
) => {
  const [start, end] = dates;

  if (!start) {
    setStartDate(null);
    setEndDate(null);
    return;
  }

  const [startHours, startMinutes] = startTime.split(":").map(Number);

  const newStart = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  newStart.setHours(startHours, startMinutes, 0, 0);

  let newEnd: Date | null = null;

  if (end) {
    const [endHours, endMinutes] = endTime.split(":").map(Number);

    newEnd = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    newEnd.setHours(endHours, endMinutes, 0, 0);
  }

  setStartDate(newStart);
  setEndDate(newEnd);
};
